import React from 'react'

import PerfectScrollBar from 'react-perfect-scrollbar'

import { Paper, Switch, Box } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

const TableTaxes = ({
  taxes = [],
  readOnly = false,
  onChangeTax,
  checkedTaxes = [],
}) => {
  return (
    <Box>
      <Paper>
        <PerfectScrollBar>
          <Table
            size="small"
            emptyMessage="Não há impostos configurados ou ativos"
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Escopo</TableCell>
                {!readOnly && <TableCell></TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {taxes.map(tax => (
                <TableRow key={tax.id}>
                  <TableCell>{tax.name}</TableCell>
                  <TableCell>{tax.value}%</TableCell>
                  <TableCell>{tax.scope}</TableCell>
                  {!readOnly && (
                    <TableCell align="right">
                      <Switch
                        onChange={event => onChangeTax(event, tax)}
                        checked={checkedTaxes.some(
                          checkedTax => checkedTax.id === tax.id,
                        )}
                        size="small"
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PerfectScrollBar>
      </Paper>
    </Box>
  )
}

export default TableTaxes
